import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {BasketLine} from "./basket-line";

export class Basket {

    id: string;
    customer_name: string;
    customer_lastname: string;
    customer_address: string;
    basket_lines: BasketLine[];

    static _JSONProps: string[] = [
        'id', 'customer_name', 'customer_lastname',
        'customer_address'
    ];

    constructor(initializer?: BasketJSON) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: BasketJSON | string): Basket {
        if (json === null) {
            return new Basket();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, Basket.reviver);
        } else {
            let task = Object.create(Basket.prototype);

            let extra = {basket_lines: []};

            Object.keys(json).forEach((key, index) => {
                if (Basket._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'basket_lines') {
                    json[key].forEach((value: BasketLine, index) => {
                        extra.basket_lines.push(BasketLine.fromJSON(value));
                    });
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? Basket.fromJSON(value) : value;
    }

    public formattedDate(field: string, format: string) {
        if (this[field]) {
            let thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface BasketJSON {
    id?: number;
    task_id: number;
    customer_id: number;
    user_id: number;
    description: string;
    completed: boolean;
    date;
    start_time?;
    stop_time?;
}
